import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AdminForm from "../AdminForm";
import { addComment } from "./commentsAdminSlice";

const field = {
  title: "Информация",
  data: [
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Име на клиента",
      name: "reviewerName",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Град/село",
      name: "location",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Заглавие",
      name: "title",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Съдържание",
      name: "content",
    },
    {
      required: true,
      options: undefined,
      type: "number",
      title: "Оценка 1-5",
      name: "rating",
    },
  ],
};

const AddComment = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    dispatch(
      addComment(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <AdminForm
      formTitle="Добавяне на коментар"
      onSubmit={onSubmit}
      field={field}
      progress={progress}
    />
  );
};

export default AddComment;
